/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from "../../constants/Colors";
import { FontWeight } from "../Text";
import { Breakpoints } from "../../constants/Breakpoints";
import { mediaHelper, mediaHelperMaxWidth } from "../../utils/src";

const NotificationsContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  margin-left: 10%;
  font-family: 'Fira Sans', sans-serif;
`;

const NotificationsHeader = styled.div`
    width: 100%; 
    height: 5%
    display: inline-flex; 
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 2%;

    @media(max-width: ${Breakpoints.sm}) {
      padding: 2%
      border-top: 1px solid black;
    }
`;

const NotificationsCounter = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;

const NotificationsSettings = styled.div`
  gap: 10px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;

const Text = styled.text`
  color: ${(props) => (props.secundary ? Colors.PURPLE : Colors.GRAY[6])};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 15px;
  cursor: pointer;

  @media(max-width: ${Breakpoints.sm}) {
    font-size: 12px;
    font-weight: ${FontWeight.Regular};
  }
  
`;

const Scrollbox = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px 10px;
  width: 100%;
  height: 100%;
  margin-top: 10px;
  max-height: 370px;
  min-height: 380px;

  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }

  @media(max-width: ${Breakpoints.sm}) {
    max-height: 100%;
    min-height: 100%;
    height: 100%;
  }
  
  @media (min-width: 1920px){
    max-height: 700px;
    height: 700px;
    min-height: 700px;
  }

`;

const NotificationsBody = styled.div`
  display: block;
  widht: 100%;
  height: 100%;
`;

const Notification = styled.div`
  width: 100%;
  border-radius: 3px;
  margin-bottom: 12px;
  border: 1.5px solid #D3D3D5;
  cursor: pointer;

  &.read {
    background-color: #FBFBFB;

    > div > div > text {
      font-weight: bold;
      color: black;
    }
  }

  &.not-read {
    background-color: #fff;
  }
`;

const NotificationContent = styled.div`
  width: 98%;
  height: 100%;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-left: 5px;
  padding: 10px;
`;

const NotificationTitle = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;

  @media(max-width: ${Breakpoints.sm}) {
    .icon-check-ok:before{
      width: 20px;
      height: 20px;
      border-radius: 12px;
      background-size: 20px 20px;
    }
  }
  
`;

const NotificationSubtitle = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
`;

const NotificationText = styled(Text)`
  font-size: 15px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};
  text-transform: none;
  pointer-events: none;

  @media (min-width: ${Breakpoints.xl}) {
    display: unset;
  }

  @media(max-width: ${Breakpoints.sm}) {
    font-size: 12px;
    font-weight: ${FontWeight.Regular};
  }
`;

const NotificationTextGrouping = styled(Text)`
  font-size: 15px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};
  text-transform: none;
  font-weight: bold;
  

  @media(max-width: ${Breakpoints.sm}) {
    font-size: 12px;
    font-weight: ${FontWeight.Regular};
    font-weight: bold;
  }

  @media (min-width: ${Breakpoints.xl}) {
    display: unset;
  }
`;

export const TooltipText = styled.div`
`;

export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: -30px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: auto;
  padding: 5px 5px;
  border-radius: 4px;
  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;
  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 30px;
    top: -10px;
    position: absolute;
    border: 10px solid transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
    z-index: 150;
  }
  div {
    overflow: hidden;
 }
`;

export const TooltipCard = styled.div`
  position: relative;
  & ${TooltipText}:hover + ${TooltipBox} {
    visibility: visible;
    color: ${Colors.WHITE};
    background-color: rgba(0, 0, 0);
    width: auto;
    padding: 8px 8px;
    &:before {
      border-color: transparent transparent rgba(0, 0, 0)
        rgba(0, 0, 0);
    }
    z-index: 150;
  }
`;

export {
  NotificationsContainer,
  NotificationsHeader,
  Text,
  NotificationsCounter,
  NotificationsSettings,
  Scrollbox,
  NotificationsBody,
  Notification,
  NotificationTitle,
  NotificationSubtitle,
  NotificationContent,
  NotificationText,
  NotificationTextGrouping,
};
